import React, { useContext, useEffect } from "react";
import { AuthContext } from "../../services/AuthContext";
import { RadioContext } from "../../services/RadioProvider";
import "./LLogo.css";

export default function LLogo() {
    const { isLoggedIn, setUserModalOpen } = useContext(AuthContext);
    const { nowPlaying } = useContext(RadioContext);
    const { listeners } = nowPlaying

    useEffect(() => {
    }, [nowPlaying]);

    const className = isLoggedIn ? "l-is-logged-in" : "l-is-not-logged-in";
    return (
        <div className="l-logo-main">
            <div className="l-logo-img-link">
                <div className="l-logo-text">
                    <a  href="https://cueroom.online">
                        <img className="l-vip-logo" src="/images/logo.png" alt="VIP Radio Logo" />
                    </a>
                </div>
                {/* <div className="d-logo-text">
                    <a href="https://vip-radio.online">
                        <div className="d-vip">VIP-RADIO.ONLINE</div>
                        <div className="d-cool">Cool Online Music</div>
                    </a>
                </div> */}
                <button className={`l-user ${className}`} onClick={() => setUserModalOpen(true)}><i className="fas fa-user"></i></button>
            </div>
            {/* <div className="l-logo-listeners">
                <h1>
                    <div className="l-title-listeners">
                        <div>
                            <i className="fas fa-headphones"></i>
                            <span className="l-listener-count">{listeners}</span>
                        </div>
                    </div>
                </h1>
            </div> */}
        </div>
    );
}